import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConfig } from '../../app.config';
import { DatastoreService } from '../../services/datastore.service';
import { DobValidatorService } from '../../services/dob-validator.service';
import { ApiService } from '../../services/jrni/api.service';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { BasketService } from '../../services/jrni/basket.service';
import { DepartmentService } from '../../services/jrni/department.service';
import { MemberService } from '../../services/jrni/member.service';
import { ServicesService } from '../../services/jrni/services.service';
import { AlertService } from '../../_alert';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { AmazonService } from '../../services/jrni/amazon.service';
import { BookingTimerService } from '../../services/booking-timer.service';

@Component({
  selector: 'app-booking-details',
  templateUrl: './booking-details.component.html',
  styleUrls: ['./booking-details.component.scss'],
})
export class BookingDetailsComponent implements OnInit {
  parentDepartment;
  selectedDepartment;
  selectedService;
  pageTitle: string;
  dataPolicy: string;
  dataPolicyTwo: string;
  declaration_question_override: string;
  bookingDetailsPageText: string;
  bookingQuestions = [];
  submitted: boolean;
  selectedLocation;
  requiresFullRegistration = false;
  organisationQuestions = [];
  today = new Date();
  selectedFile: string;
  subtmitButtonDisabled: boolean;
  bookingQuestionsConfig = AppConfig.settings.bookingQuestions;
  public dvlaLookupQuestionMap = AppConfig.settings.dvlaLookupQuestionMap;
  vehicleStatus: any = 0;
  addresses = [];
  addressFoundBefore = false;
  member;
  slot;
  banned = false;
  customerQuestions;
  unavailableTimes = [];
  // https://regexr.com/3pp3r <- Postcode validator
  postcodeValidator =
    '^(([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))s?[0-9][A-Za-z]{2}))$';
  showingAddresses = false;
  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;
  selectedAddressId;
  custodian_codes = [3600, 3605, 3610, 3615, 3620, 3625, 3630, 3635, 3640, 3645, 3650, 3655, 355];
  isInLocalArea: boolean = false;
  showWasteWarning: boolean = false;
  wasteLimit: any = {};
  wasteUnits: string = 'litres';
  permitQuestion = AppConfig.settings.permitQuestion.toString();
  visibleContactQuestions: string;
  bookingQuestionsForm: UntypedFormGroup;
  formattedTime = { minutes: 15, seconds: 0 };
  showVisualWarning = false;
  a11yWarningMessage = '';

  constructor(
    private router: Router,
    private servicesService: ServicesService,
    private departmentService: DepartmentService,
    private formBuilder: UntypedFormBuilder,
    private basketservice: BasketService,
    private alertService: AlertService,
    private translateService: TranslateService,
    private memberService: MemberService,
    public datastoreService: DatastoreService,
    private spinner: NgxSpinnerService,
    private apiService: ApiService,
    private amazonService: AmazonService,
    private availabilityService: AvailabilityService,
    private bookingTimerService: BookingTimerService
  ) { }

  // Initialise the customer form
  customerDetailsForm: UntypedFormGroup = new UntypedFormGroup(
    {
      first_name: new UntypedFormControl('', Validators.required),
      last_name: new UntypedFormControl('', Validators.required),
      // have_email: new UntypedFormControl('', Validators.required),
      email_address: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i),
      ]),
      confirm_email: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i),
      ]),
      // postcode: new FormControl("", [Validators.required, Validators.pattern(this.postcodeValidator)]),
      mobile_number: new UntypedFormControl(''),
      privacy_notice: new UntypedFormControl(false, Validators.requiredTrue),
      // terms_and_conditions: new UntypedFormControl(
      //   false,
      //   Validators.requiredTrue
      // ),
    },
    {
      validators: this.matchingEmailsValidator(
        'email_address',
        'confirm_email'
      ),
    }
  );

  addressEnabled = AppConfig.settings.addressApi.enabled;

  matchingEmailsValidator(
    emailKey: string,
    confirmEmailKey: string
  ): ValidatorFn {
    return (group: UntypedFormGroup): { [key: string]: any } => {
      let email = group.controls[emailKey];
      let confirmEmail = group.controls[confirmEmailKey];

      // If the email and confirm email inputs have data
      if (email.value.length > 0 && confirmEmail.value.length > 0) {
        // Check if the emails match
        if (email.value.toLowerCase() !== confirmEmail.value.toLowerCase()) {
          confirmEmail.setErrors({ mismatch: true });
          return {
            mismatch: true,
          };
        } else if (confirmEmail.errors && confirmEmail.errors.mismatch) {
          // If the errors object does not contain any other errors then set errors {} to null
          if (Object.keys(confirmEmail.errors).length == 1) {
            confirmEmail.setErrors(null);
          } else {
            // Delete the mismatch error from the object as we do not want to remove any other errors that exist in the {}
            delete confirmEmail.errors.mismatch;
          }
        } else {
          confirmEmail.setErrors(null);
          return null;
        }
      }
    };
  }

  // Getter for easy access to form fields
  get form() {
    return this.customerDetailsForm.controls;
  }
  get bookingForm() {
    return this.bookingQuestionsForm.controls;
  }

  routerGoBack() {
    this.router.navigate(['/calendar']);
  }

  restartJourney() {
    this.router.navigate(['/departments']);
  }

  localAddress() {
    const e = this.customerDetailsForm.value.selectedAddress.address;
    const matchingCodes = this.custodian_codes.filter((code) => {
      if (e.LOCAL_CUSTODIAN_CODE === code) {
        return true;
      }
    });
    if (matchingCodes.length > 0) return true;
    else return false;
  }

  checkAddress(addr: any) {
    const matchingCodes = this.custodian_codes.filter((code) => {
      if (addr.LOCAL_CUSTODIAN_CODE === code) {
        return true;
      }
    });
    if (matchingCodes.length > 0) return true;
    else return false;
  }

  async getVehicle() {
    this.spinner.show();
    console.log(this.bookingQuestionsForm);
    console.log(this.dvlaLookupQuestionMap.regQuestionId);
    console.log(this.bookingQuestionsForm.controls[
      this.dvlaLookupQuestionMap.regQuestionId
    ]);
    let vehiclereg: String =
      this.bookingQuestionsForm.controls[
        this.dvlaLookupQuestionMap.regQuestionId
      ].value;
    this.datastoreService.registration = vehiclereg
      .toLowerCase()
      .replace(/\s/g, '');
    try {
      const vehicleLookup: any = await this.apiService.getVehicleDetails(
        vehiclereg
      );

      if (vehicleLookup.error) {
        let indexOfErrorCode = vehicleLookup.message.indexOf(
          ' ',
          vehicleLookup.message.indexOf(':') + 1
        ); // get first : from the error string

        let statusCodeErrorMessage = vehicleLookup.message.substring(
          indexOfErrorCode + 1,
          indexOfErrorCode + 4
        );

        if (statusCodeErrorMessage == '404') {
          this.vehicleStatus = 2;
        } else {
          this.vehicleStatus = 3;
        }
      } else {
        this.bookingQuestionsForm.controls[
          this.dvlaLookupQuestionMap.makeQuestionId
        ].setValue(vehicleLookup['result'].make);
        this.bookingQuestionsForm.controls[
          this.dvlaLookupQuestionMap.makeQuestionId
        ].patchValue(vehicleLookup['result'].make);

        this.bookingQuestionsForm.controls[
          this.dvlaLookupQuestionMap.colourQuestionId
        ].setValue(vehicleLookup['result'].colour);
        this.bookingQuestionsForm.controls[
          this.dvlaLookupQuestionMap.colourQuestionId
        ].patchValue(vehicleLookup['result'].colour);

        this.vehicleStatus = 1;
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.log(error);
    }
  }

  async getAddress(repopulate: boolean = null) {
    this.showingAddresses = false;

    // Clear the addresses array
    this.addresses.length = 0;
    this.customerDetailsForm.controls.selectedAddress.setValue('');

    // Custom error handling for postcode
    let postcode: String = this.customerDetailsForm.value.postcode.replace(/\s/g, '');
    this.customerDetailsForm.controls.postcode.setValue(postcode);
    if (this.customerDetailsForm.controls.postcode.status == 'INVALID') {
      this.customerDetailsForm.get('postcode').setErrors({
        invalidPostcode: this.translateService.instant(
          'COMMON.INVALID_POSTCODE'
        ),
      });
      return;
    }
    this.spinner.show();
    const res = await this.amazonService.osGetNameDataEncodedApi(
      this.customerDetailsForm.value.postcode
    );
    if (
      this.customerDetailsForm.controls.postcode.errors &&
      this.customerDetailsForm.controls.postcode.errors.invalidPostcode
    ) {
      delete this.customerDetailsForm.controls.postcode.errors.invalidPostcode;
    }
    var object: any = res;
    if (object.results) {
      if (
        this.customerDetailsForm.controls.postcode.errors &&
        this.customerDetailsForm.controls.postcode.errors.addressNotFound
      ) {
        delete this.customerDetailsForm.controls.postcode.errors
          .addressNotFound;
      }
      var addresses = object.results;

      const addressesExist = addresses.filter((e) => {
        if (e.DPA) {
          return true;
        } else if (e.LPI) {
          return true;
        }
      });

      const addressException = await this.apiService.getAddressException();
      let expections = [];

      if (addressException) {
        expections = addressException['Items'];
      }

      let added = [];
      console.log(addressesExist);
      if (addressesExist.length > 1) {
        // If it matches up, push the addresses
        let localCodes = [];
        addressesExist.forEach((item) => {
          const expectionAddress = expections.find(({ UPRN }) => {
            if (item.DPA) {
              if (UPRN === item.DPA.UPRN) {
                return true;
              }
            }
            if (item.LPI) {
              if (UPRN === item.LPI.UPRN) {
                return true;
              }
            }

            return false;
          });

          const addedAlready = added.find(({ ADDRESS }) => {
            if (item.DPA) {
              if (ADDRESS === item.DPA.ADDRESS) {
                return true;
              }
            }
            if (item.LPI) {
              if (ADDRESS === item.LPI.ADDRESS) {
                return true;
              }
            }

            return false;
          });

          let alreadyEntered = false;

          if (expectionAddress === undefined) {
            alreadyEntered = this.addresses.some((e) => {
              if (item.DPA && item.DPA.UPRN === e.address.UPRN) {
                return true;
              } else if (item.LPI && item.LPI.UPRN === e.address.UPRN) {
                return true;
              }
            });
          }

          if (!alreadyEntered && addedAlready === undefined) {
            if (item.DPA) {
              const inLocalArea = this.checkAddress(item.DPA);
              if (inLocalArea) {
                this.addresses.push({ address: item.DPA });
                added.push({ ADDRESS: item.DPA.ADDRESS });
                localCodes.push(inLocalArea);
              }
            } else {
              const inLocalArea = this.checkAddress(item.LPI);
              if (inLocalArea) {
                this.addresses.push({ address: item.LPI });
                added.push({ ADDRESS: item.LPI.ADDRESS });
                localCodes.push(inLocalArea);
              }
            }
          }
        });

        if (repopulate) {
          let selectedAddress =
            this.customerDetailsForm.value.selectedAddress.address.ADDRESS;
          for (let i = 0; i < this.addresses.length; i++) {
            let item = this.addresses[i];
            if (selectedAddress == item.address.ADDRESS) {
              this.selectedAddressId = i;
            }
          }
        }

        if (localCodes.length > 0) {
          this.addresses = this.addresses.filter(
            (x) =>
              x.address.CLASSIFICATION_CODE[0] === 'R' ||
              x.address.CLASSIFICATION_CODE[0] === 'P' ||
              x.address.CLASSIFICATION_CODE[0] === 'PP' ||
              x.address.CLASSIFICATION_CODE[0] === 'C'
          );
          if (this.addresses.length === 0) {
            this.customerDetailsForm.get('postcode').setErrors({
              addressNotFound: this.translateService.instant(
                'COMMON.ADDRESS_NOT_FOUND_RES'
              ),
            });
            this.spinner.hide();
          } else {
            this.showingAddresses = true;
            this.isInLocalArea = true;
          }
        } else {
          this.showingAddresses = true;
          this.isInLocalArea = false;
        }
      } else {
        // If it doesn't match up, show an error message
        console.log('dsd', addressesExist);
        this.customerDetailsForm.get('postcode').setErrors({
          invalidPostcode: this.translateService.instant(
            'COMMON.ADDRESS_NOT_ELIGIBLE'
          ),
        });
      }
    } else {
      this.customerDetailsForm.get('postcode').setErrors({
        addressNotFound: this.translateService.instant(
          'COMMON.ADDRESS_NOT_FOUND'
        ),
      });
    }
    this.spinner.hide();
  }

  async checkVisitorAlertsTable(registration) {
    this.datastoreService.banned = false;
    this.datastoreService.observe = false;

    const res: any = await this.apiService.getAlertTableStatus(
      registration.replace(/\s/g, '').toUpperCase()
    );
    console.log(res);
    if (res) {
      console.log(res.hasOwnProperty('found'), res.found);
      if (res.hasOwnProperty('found')) {
        for (let find of res.found) {
          console.log(find);
          console.log(find.status === 'BANNED');
          if (find.status === 'BANNED') {
            this.datastoreService.banned = true;
          }
          if (find.status === 'OBSERVE') {
            this.datastoreService.observe = true;
          }
        }
      }
    }
  }

  async bannedRegistrationCheck(registration) {
    // Banned vehicle registrations from API
    // if (this.parentDepartment.extra.banned_vehicle_registration_numbers) {
    // If there are any banned vehicle registration numbers, run the check
    // var str = this.parentDepartment.extra.banned_vehicle_registration_numbers.replace(/\s/g, '').toLowerCase();
    // var banned = new Array();
    // banned = str.split(",");
    var banned: any = await this.apiService.getBanned();
    // Value to return
    // Check for match between banned registrations and users registration
    console.log(banned);
    if (banned.registrations) {
      for (let item of banned.registrations) {
        if (item.regno) {
          if (
            item.regno.replace(/\s/g, '').toLowerCase() ==
            registration.replace(/\s/g, '').toLowerCase()
          ) {
            return true;
          }
        } else {
          if (
            item.replace(/\s/g, '').toLowerCase() ==
            registration.replace(/\s/g, '').toLowerCase()
          ) {
            return true;
          }
        }
      }
      return false;
    } else {
      return false;
    }
  }

  formatPostcode() { }

  ngOnInit() {
    this.bookingTimerService.startTimer();
     this.bookingTimerService.timer$.subscribe((seconds) => {
      this.formattedTime = {
        minutes: Math.floor(seconds / 60),
        seconds: seconds % 60,
      };
    });
    this.bookingTimerService.warn$.subscribe((warn) => {
    if (warn) {
      this.showVisualWarning = true;
      this.a11yWarningMessage = 'You have one minute remaining to complete your booking.';
    }
    });
    // Initialise the form
    this.bookingQuestionsForm = this.formBuilder.group({});

    this.scrollToTop();

    if (this.addressEnabled) {
      this.customerDetailsForm.addControl(
        'postcode',
        new UntypedFormControl('', [
          Validators.required,
          Validators.pattern(this.postcodeValidator),
        ])
      );
      this.customerDetailsForm.addControl(
        'selectedAddress',
        new UntypedFormControl('', Validators.required)
      );
    }

    this.availabilityService.getSelectedSlot().then((slot) => {
      if (slot) {
        this.slot = slot;
      }
    });

    this.parentDepartment = this.datastoreService.parentDepartment;

    if (this.parentDepartment) {
      this.spinner.show();
      this.selectedDepartment = this.datastoreService.selectedDepartment;
      let registrationOption = '';
      let organisationQuestionsID;

      // Set the title on the login page to the title from the business question
      this.parentDepartment.extra?.hasOwnProperty('booking_details_page_title')
        ? (this.pageTitle =
          this.parentDepartment.extra.booking_details_page_title)
        : (this.pageTitle = 'Booking details title not set');

      // Get the configurable data
      if (this.parentDepartment.hasOwnProperty('extra')) {
        // Set the extra text on the page to the text taken from the business question

        this.parentDepartment.extra.hasOwnProperty(
          'declaration_question_override'
        )
          ? (this.declaration_question_override =
            this.parentDepartment.extra.declaration_question_override)
          : (this.declaration_question_override =
            'declaration question not set');

        this.parentDepartment.extra.hasOwnProperty('booking_details_page_text')
          ? (this.bookingDetailsPageText =
            this.parentDepartment.extra.booking_details_page_text)
          : null;

        // Set the extra text on the page to the text taken from the business question
        this.parentDepartment.extra.hasOwnProperty('booking_details_page_text')
          ? (this.bookingDetailsPageText =
            this.parentDepartment.extra.booking_details_page_text)
          : null;
        // Get the registration option
        this.parentDepartment.extra.hasOwnProperty('registration_option')
          ? (registrationOption =
            this.parentDepartment.extra.registration_option)
          : null;
        // Get the organistion customer questions
        this.parentDepartment.extra.hasOwnProperty('organisations_questions')
          ? (organisationQuestionsID =
            this.parentDepartment.extra.organisations_questions)
          : null;

        // If the register option is set to complete a full registration then capture the following details
        if (registrationOption.toLowerCase() === 'register complete details') {
          this.requiresFullRegistration = true;
        }
      }

      //     // Use this.departmentService.getLocation() if the services are set on the children departments
      //     // Use this.departmentService.get() if the services are set on the parent department
      this.departmentService.get().then(async (location) => {
        this.selectedLocation = location;

        // Delete any exisitng baskets to avoid conflicts
        if (this.basketservice.currentBasket) {
          await this.basketservice.delete(
            this.selectedLocation,
            this.basketservice.currentBasket
          );
        }
        // Create the basket
        this.basketservice.createBasket(location).then(
          (basket) => {
            this.basketservice.currentBasket = basket;

            this.memberService.getMember().then((member) => {
              this.member = member;

              // Get the customer questions
              this.departmentService
                .getCustomerQuestions()
                .then((questions) => {
                  this.customerQuestions = questions;
                  this.datastoreService.customerQuestions = questions;
                  for (
                    let index = 0;
                    index < this.customerQuestions.length;
                    index++
                  ) {
                    const question = this.customerQuestions[index];
                    question.visible = false;
                    question.reference = question.id;
                    if (!question.admin_only) {
                      if (
                        !question.settings.hasOwnProperty(
                          'conditional_question'
                        )
                      ) {
                        question.visible = true;
                      }

                      const questionControl = question.id;
                      if (
                        question.detail_type == 'check' ||
                        question.detail_type == 'check-price'
                      ) {
                        if (question.default == 1) {
                          if (question.required) {
                            this.customerDetailsForm.addControl(
                              questionControl,
                              new UntypedFormControl(true, Validators.required)
                            );
                          } else {
                            this.customerDetailsForm.addControl(
                              questionControl,
                              new UntypedFormControl(true)
                            );
                          }
                        } else {
                          if (question.required) {
                            this.customerDetailsForm.addControl(
                              questionControl,
                              new UntypedFormControl(false, Validators.required)
                            );
                          } else {
                            this.customerDetailsForm.addControl(
                              questionControl,
                              new UntypedFormControl(false)
                            );
                          }
                        }
                      } else {
                        if (questionControl === 382) {
                          // postcode custom question needs validation
                          // if (!this.addressEnabled) {  // postcode custom question not needed if we are doing address lookup
                          //   if (question.required) {
                          //     this.customerDetailsForm.addControl(questionControl, new FormControl('', [Validators.required, Validators.pattern(this.postcodeValidator)]));
                          //   } else {
                          //     this.customerDetailsForm.addControl(questionControl, new FormControl('', Validators.pattern(this.postcodeValidator)));
                          //   }
                          //   this.customerDetailsForm.get("382").valueChanges.subscribe(value => { //force uppercase and space removal
                          //     if (value !== value.replace(/\s/g, "").toUpperCase().slice(0, 8)) {
                          //       this.customerDetailsForm.controls["382"].setValue(value.replace(/\s/g, "").toUpperCase().slice(0, 8));
                          //     }
                          //   });
                          // }
                        } else {
                          if (question.required) {
                            this.customerDetailsForm.addControl(
                              questionControl,
                              new UntypedFormControl('', Validators.required)
                            );
                          } else {
                            this.customerDetailsForm.addControl(
                              questionControl,
                              new UntypedFormControl('')
                            );
                          }
                        }
                      }
                    }
                  }
                });
            });
            this.spinner.hide();
          },
          (err) => {
            this.alertService.error(
              this.translateService.instant('COMMON.GENERAL_ERR')
            );
            this.spinner.hide();
          }
        );
      });

      //     // Get the selected service
      this.servicesService.get().then((service) => {
        this.selectedService = service;
        console.log(this.selectedService);
        this.parentDepartment.extra.hasOwnProperty('data_policy')
          ? (this.dataPolicy = this.parentDepartment.extra.data_policy)
          : (this.dataPolicy = 'privacy notice not set');
        this.selectedService.extra.hasOwnProperty('terms_and_conditions')
          ? (this.dataPolicyTwo =
            this.selectedService.extra.terms_and_conditions)
          : (this.dataPolicyTwo = 'terms and conditions not set');
        // Get the questions
        this.selectedService.$get('questions').then(async (res) => {
          let bookingQuestions = [];
          for (const q of res.questions) {
            if (this.selectedLocation.id === 37005) {
              if (q.id !== 10 && q.id.toString() !== this.permitQuestion) {
                bookingQuestions.push(q);
              }
            } else {
              bookingQuestions.push(q);
            }
          }
          this.bookingQuestions = bookingQuestions;
          this.datastoreService.bookingQuestions = this.bookingQuestions;

          for (let index = 0; index < bookingQuestions.length; index++) {
            const question = bookingQuestions[index];
            question.visible = false;
            question.reference = question.id;
            if (!question.admin_only) {
              if (!question.settings.hasOwnProperty('conditional_question')) {
                question.visible = true;
              }
              const questionControl = question.id;

              if (
                question.detail_type == 'check' ||
                question.detail_type == 'check-price'
              ) {
                if (question.required) {
                  this.bookingQuestionsForm.addControl(
                    questionControl,
                    new UntypedFormControl(false, Validators.requiredTrue)
                  );
                } else {
                  this.bookingQuestionsForm.addControl(
                    questionControl,
                    new UntypedFormControl(false)
                  );
                }
              } else {
                if (question.required) {
                  this.bookingQuestionsForm.addControl(
                    questionControl,
                    new UntypedFormControl('', Validators.required)
                  );
                } else {
                  this.bookingQuestionsForm.addControl(
                    questionControl,
                    new UntypedFormControl('')
                  );
                }
              }
            }
          }

          if (this.selectedService.permitQuestion) {
            this.bookingQuestionsForm.controls[
              AppConfig.settings.vehicleHireQuestion
            ].setValue(this.selectedService.permitQuestion.hire);
            this.bookingQuestionsForm.controls[
              AppConfig.settings.vehicleHireQuestion
            ].disable();
            if (this.selectedService.vehicleRegQuestion.answer) {
              this.bookingQuestionsForm.controls[
                this.selectedService.vehicleRegQuestion.id
              ].setValue(this.selectedService.vehicleRegQuestion.answer);
              console.log(
                this.bookingQuestionsForm.controls[
                this.selectedService.vehicleRegQuestion.id
                ]
              );
              this.bookingQuestionsForm.controls[
                this.selectedService.vehicleRegQuestion.id
              ].disable();
              await this.getVehicle();
              if (this.selectedService.vehicleRegQuestion.vehicle_model) {
                this.bookingQuestionsForm.controls[
                  AppConfig.settings.vehicleModelQuestion
                ].setValue(
                  this.selectedService.vehicleRegQuestion.vehicle_model
                );
                this.bookingQuestionsForm.controls[
                  AppConfig.settings.vehicleModelQuestion
                ].disable();
              }
            } else {
              this.bookingQuestionsForm.controls[
                this.selectedService.vehicleRegQuestion.id
              ].disable();
              this.bookingQuestions.find(
                (x) => x.id === this.selectedService.vehicleRegQuestion.id
              ).permanentlyHidden = true;
              this.bookingQuestions.find(
                (x) => x.id === this.dvlaLookupQuestionMap.colourQuestionId
              ).permanentlyHidden = true;
              this.bookingQuestions.find(
                (x) => x.id === this.dvlaLookupQuestionMap.makeQuestionId
              ).permanentlyHidden = true;
              this.bookingQuestionsForm.controls[
                AppConfig.settings.vehicleModelQuestion
              ].disable();
              this.bookingQuestions.find(
                (x) => x.id === AppConfig.settings.vehicleModelQuestion
              ).permanentlyHidden = true;
              this.vehicleStatus = 1;
            }
          }
          this.bookingQuestionsForm.controls[
            this.dvlaLookupQuestionMap.colourQuestionId
          ].disable();
          this.bookingQuestionsForm.controls[
            this.dvlaLookupQuestionMap.makeQuestionId
          ].disable();
          // Repopulate the booking questions when coming back
          this.datastoreService.bookingForm ? this.repopulateQuestions() : null;
        });
      });
    } else {
      this.restartJourney();
    }
  }

  repopulateQuestions() {
    this.bookingQuestionsForm = this.datastoreService.bookingForm;
    this.customerDetailsForm = this.datastoreService.customerDetailsForm;
    this.vehicleStatus = 1;
    this.onQuestionChange();
    this.onHaveEmailChange();
  }

  onQuestionChange() {
    const bookingQuestions = this.bookingQuestions;
    // Conditional questions logic
    for (let index = 0; index < bookingQuestions.length; index++) {
      const q = bookingQuestions[index];
      // If the question has settings and relies on a conditional question
      if (q.settings && q.settings.hasOwnProperty('conditional_question')) {
        // Get the conditional question based on the id set in q
        const conditionalQ = bookingQuestions.filter(
          (question) => question.id == q.settings.conditional_question
        );
        // Get the question control
        const questionControl =
          this.bookingForm[q.settings.conditional_question];
        // If the question control has a value get the option from the contional question. This will allow
        // us to check if q is shown when value is selected
        if (conditionalQ[0].hasOwnProperty('options')) {
          const option = conditionalQ[0].options.filter(
            (option) => option.name == questionControl.value
          );
          // If the conditional question is visible and the value chosen === to qs conditional answer then show q
          if (
            conditionalQ.length > 0 &&
            conditionalQ[0].visible &&
            option.length > 0 &&
            q.settings.conditional_answers.hasOwnProperty(option[0].id)
          ) {
            this.bookingForm[q.id].enable();
            // If the condiditonal question is important, Hide it
            if (q.important) {
              q.visible = false;
            } else {
              q.visible = true;
            }
          } else {
            q.visible = false;
            this.bookingForm[q.id].setValue('');
            this.bookingForm[q.id].disable();
          }
        } else {
          if (
            questionControl.value &&
            conditionalQ.length > 0 &&
            conditionalQ[0].visible
          ) {
            this.bookingForm[q.id].enable();
            if (q.important) {
              q.visible = false;
            } else {
              q.visible = true;
            }
          } else {
            q.visible = false;
            this.bookingForm[q.id].setValue('');
            this.bookingForm[q.id].disable();
          }
        }
      }
    }
  }

  onHaveEmailChange() {
    if (this.customerDetailsForm.controls['have_email'].value === 'Yes') {
      this.customerDetailsForm.controls['email_address'].enable();
      this.customerDetailsForm.controls['confirm_email'].enable();
      this.customerDetailsForm.controls['mobile_number'].disable();
      this.customerDetailsForm.controls['mobile_number'].setValue('');
      this.visibleContactQuestions = 'email';
    } else if (this.customerDetailsForm.controls['have_email'].value === 'No') {
      this.customerDetailsForm.controls['mobile_number'].enable();
      this.customerDetailsForm.controls['email_address'].disable();
      this.customerDetailsForm.controls['email_address'].setValue('');
      this.customerDetailsForm.controls['confirm_email'].disable();
      this.customerDetailsForm.controls['confirm_email'].setValue('');
      this.visibleContactQuestions = 'phone';
    } else {
      this.visibleContactQuestions = '';
      this.customerDetailsForm.controls['mobile_number'].enable();
      this.customerDetailsForm.controls['email_address'].enable();
      this.customerDetailsForm.controls['confirm_email'].enable();
      this.customerDetailsForm.controls['mobile_number'].setValue('');
      this.customerDetailsForm.controls['email_address'].setValue('');
      this.customerDetailsForm.controls['confirm_email'].setValue('');
    }
  }

  onMobileChange(event) {
    if (this.customerDetailsForm.controls['mobile_number'].value) {
      let stringMobile =
        this.customerDetailsForm.controls['mobile_number'].value.toString();
      if (stringMobile.length > 11) {
        // max 11
        // event.preventDefault()
        stringMobile = stringMobile.slice(0, 11);
        this.customerDetailsForm.controls['mobile_number'].setValue(
          parseInt(stringMobile)
        );
      }
    }
  }

  onFileChange(event, questionId) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.form[questionId].setValue(file, { emitModelToViewChange: false });
      this.bookingQuestionsForm.patchValue({
        fileSource: file,
      });
    }
  }

  async onSubmit() {
    this.spinner.show();
    this.submitted = true;
    this.alertService.clear();
    console.log(this.customerDetailsForm);
    console.log(this.bookingQuestionsForm);
    console.log(this.customerDetailsForm.invalid, this.bookingQuestionsForm.invalid);
    // Check if form is valid
    if (this.customerDetailsForm.invalid || this.bookingQuestionsForm.invalid) {
      this.scrollToTop();
      this.spinner.hide();
      this.alertService.warn(
        this.translateService.instant('FORM.VALIDATION_ERR_MSG')
      );
      return;
    }

    if (
      this.bookingQuestions.find(
        (x) =>
          x.id.toString() ===
          this.dvlaLookupQuestionMap.regQuestionId.toString()
      ).visible
    ) {
      if (this.vehicleStatus === 0) {
        this.scrollToTop();
        console.log("this.vehicleStatus", this.vehicleStatus)
        this.alertService.warn(
          this.translateService.instant('FORM.VALIDATION_ERR_MSG')
        );
        this.spinner.hide();
        return;
      }
    } else {
      this.vehicleStatus === 0;
      this.datastoreService.registration = '';
    }

    var currentDate = new Date(this.slot.datetime);

    // for some reason this function sometimes doesn't get run, adding the console logs fixed this (not sure why)

    await this.apiService
      .checkForDoubleBooking(
        this.selectedDepartment,
        currentDate,
        this.customerDetailsForm.value.email_address
          ? this.customerDetailsForm.value.email_address
          : null,
        null
      )
      .then((res: []) => {
        // res = array of unavailable times
        this.unavailableTimes = res;

        this.completeBooking();
      });
  }

  async completeBooking() {
    // now check restricetd waste
    for (const q of this.bookingQuestions) {
      const value = this.bookingQuestionsForm.value[q.id];
      if (q.id === 8) {
        this.datastoreService.isRestrictedBooking = value;
      }
      if (q.id === 11) {
        this.datastoreService.isRestrictedAsbestosBooking = value;
      }

      // Commercial wast check
      // if (q.id === 10) {
      //   this.datastoreService.isCommercialBooking = value;
      // }
    }

    if (this.addressEnabled) {
      if (!this.customerDetailsForm.value.selectedAddress.address) {
        this.alertService.warn(
          this.translateService.instant('FORM.VALIDATION_ERR_MSG')
        );
        this.scrollToTop();
        this.spinner.hide();
        return;
      }

      let addressFirstPart;
      let selectedAddress;
      if (this.customerDetailsForm.value.selectedAddress.address) {
        selectedAddress =
          this.customerDetailsForm.value.selectedAddress.address;
        if (selectedAddress.LPI_KEY) {
          // IF LPI
          if (selectedAddress.PAO_START_NUMBER) {
            addressFirstPart = `${selectedAddress.SAO_TEXT ? selectedAddress.SAO_TEXT : ''
              } ${selectedAddress.PAO_START_NUMBER}`;
          } else if (selectedAddress.PAO_TEXT) {
            addressFirstPart = `${selectedAddress.SAO_TEXT ? selectedAddress.SAO_TEXT : ''
              } ${selectedAddress.PAO_TEXT}`;
          }
        } else {
          // IF DPA
          if (
            this.customerDetailsForm.value.selectedAddress.address
              .BUILDING_NUMBER &&
            this.customerDetailsForm.value.selectedAddress.address
              .ORGANISATION_NAME
          ) {
            addressFirstPart = `${this.customerDetailsForm.value.selectedAddress.address.ORGANISATION_NAME}, ${this.customerDetailsForm.value.selectedAddress.address.BUILDING_NAME}, ${this.customerDetailsForm.value.selectedAddress.address.BUILDING_NUMBER},`;
          } else {
            if (
              this.customerDetailsForm.value.selectedAddress.address
                .BUILDING_NUMBER &&
              this.customerDetailsForm.value.selectedAddress.address
                .ORGANISATION_NAME
            ) {
              addressFirstPart = `${this.customerDetailsForm.value.selectedAddress.address.BUILDING_NUMBER}, ${this.customerDetailsForm.value.selectedAddress.address.ORGANISATION_NAME}`;
            } else if (
              this.customerDetailsForm.value.selectedAddress.address
                .BUILDING_NAME &&
              this.customerDetailsForm.value.selectedAddress.address
                .ORGANISATION_NAME
            ) {
              addressFirstPart = `${this.customerDetailsForm.value.selectedAddress.address.ORGANISATION_NAME}, ${this.customerDetailsForm.value.selectedAddress.address.BUILDING_NAME}`;
            } else {
              if (
                this.customerDetailsForm.value.selectedAddress.address
                  .BUILDING_NUMBER
              ) {
                addressFirstPart =
                  this.customerDetailsForm.value.selectedAddress.address
                    .BUILDING_NUMBER;
              } else if (
                this.customerDetailsForm.value.selectedAddress.address
                  .BUILDING_NAME
              ) {
                addressFirstPart =
                  this.customerDetailsForm.value.selectedAddress.address
                    .BUILDING_NAME;
              } else {
                addressFirstPart =
                  this.customerDetailsForm.value.selectedAddress.address
                    .ORGANISATION_NAME;
              }
            }
          }
        }
      } else {
        this.alertService.warn(
          this.translateService.instant('FORM.VALIDATION_ERR_MSG')
        );
        this.scrollToTop();
        this.spinner.hide();
        this.customerDetailsForm.get('selectedAddress').setErrors({
          required: this.translateService.instant('COMMON.ADDRESS_NOT_FOUND'),
        });
        return;
      }

      // Fix issue where the thoroughfare name and street description are not available.
      let address1 = '';
      if (
        this.customerDetailsForm.value.selectedAddress.address
          .THOROUGHFARE_NAME ||
        this.customerDetailsForm.value.selectedAddress.address
          .STREET_DESCRIPTION
      ) {
        address1 = `${addressFirstPart.toLowerCase()} ${this.customerDetailsForm.value.selectedAddress.address
          .THOROUGHFARE_NAME
          ? this.customerDetailsForm.value.selectedAddress.address.THOROUGHFARE_NAME.toLowerCase()
          : this.customerDetailsForm.value.selectedAddress.address.STREET_DESCRIPTION.toLowerCase()
          }`;
      } else {
        address1 = `${addressFirstPart.toLowerCase()} ${this.customerDetailsForm.value.selectedAddress.address
          .DEPENDENT_LOCALITY
          }`;
      }

      this.datastoreService.address1 = selectedAddress.ADDRESS.toLowerCase();

      // Check our API if the user has booked already in the past 7 days
      // If there is a weekly booking limit

      let limitReached = false;

      let failHouse = false;
      let failVehicle = false;
      let limitMonth = 0;
      try {
        if (this.datastoreService.config?.hwrcBookingLimits?.enabled) {
          const slot: any = await this.availabilityService.getSelectedSlot();
          const slotDateTime = slot.datetime;
          const selectedService = await this.servicesService.get();
          const bookingLimitDataHouse: any =
            await this.apiService.checkBookingLimit(
              this.datastoreService.parentDepartment,
              this.datastoreService.address1,
              slotDateTime,
              selectedService
            );
          limitMonth = bookingLimitDataHouse.limits.monthlyLimit;
          if (!bookingLimitDataHouse.status) {
            failHouse = true;
          }

          if (this.datastoreService.registration !== '') {
            const bookingLimitDataVehicle: any =
              await this.apiService.checkBookingLimit(
                this.datastoreService.parentDepartment,
                this.datastoreService.registration,
                slotDateTime,
                selectedService
              );
            if (!bookingLimitDataVehicle.status) {
              failVehicle = true;
            }
          }
        }
      } catch (err) {
        console.error('failed to check address limit');
        console.error(err);
      }

      if (failHouse || failVehicle) {
        if (failHouse) {
          this.alertService.error(
            this.translateService.instant(
              'FORM.HOUSEHOLD_WEEKLY_BOOKING_LIMIT_HOUSE',
              { limitMonth: limitMonth }
            )
          );
        }
        if (failVehicle) {
          this.alertService.error(
            this.translateService.instant(
              'FORM.HOUSEHOLD_WEEKLY_BOOKING_LIMIT_VEHICLE',
              { limitMonth: limitMonth }
            )
          );
        }

        this.scrollToTop();
        this.spinner.hide();
        return;
      }
    }

    this.datastoreService.config;
    let wasteLimitAnswers = [];
    let wasteLimit: any = {};
    if (this.bookingQuestionsForm.value[this.datastoreService.config.wasteLimits.haveWasteQuestion] === "Yes") {
      let parentDepartment = await this.departmentService.getParentDepartment();
      const slot: any = await this.availabilityService.getSelectedSlot();
      const slotDateTime = slot.datetime;
      wasteLimit = await this.apiService.getWasteLimit(parentDepartment.id, this.datastoreService.address1.toLowerCase().replace(/\s/g, "_"), moment(slotDateTime).format("DD-MM-YYYY"))
      if (wasteLimit.message !== undefined) {
        wasteLimit = {
          windowMaxDayLimit: {
            limit: this.datastoreService.config.wasteLimits.days,
            amount: 0,
            limitBreached: false
          },
          windowMaxWeightLimit: {
            limit: this.datastoreService.config.wasteLimits.weight,
            amount: 0,
            paid_qty: 0,
            limitBreached: false
          }
        }
      }

      if (wasteLimit.message === undefined) {
        const wasteQuestionId = this.datastoreService.config.wasteLimits.wasteQuestionId
        const answer = this.bookingQuestions.filter((x) => x.id.toString() === wasteQuestionId.toString())
        const answerId = answer[0].options.filter((x) => x.name === this.bookingQuestionsForm.value[wasteQuestionId])[0].id
        const myWeight = this.datastoreService.config.wasteLimits.wasteQuestionAnswerToWeight[answerId.toString()]

        wasteLimit.windowMaxDayLimit.amount++
        wasteLimit.windowMaxWeightLimit.amount += myWeight
        wasteLimit.windowMaxWeightLimit.amount -=  wasteLimit.windowMaxWeightLimit.paid_qty

        if (wasteLimit.windowMaxDayLimit.amount > wasteLimit.windowMaxDayLimit.limit) {
          wasteLimit.windowMaxDayLimit.limitBreached = true;
          wasteLimitAnswers.push({
            id: this.datastoreService.config.wasteLimits.overBookingLimitQuestion,
            answer: true
          })
        }

        if (wasteLimit.windowMaxWeightLimit.amount > wasteLimit.windowMaxWeightLimit.limit) {
          wasteLimit.windowMaxWeightLimit.limitBreached = true;
          wasteLimitAnswers.push({
            id: this.datastoreService.config.wasteLimits.overWeightLimitQuestion,
            answer: true
          })
        }

      }
    }

    this.datastoreService.wasteLimitAnswers = wasteLimitAnswers;
    if (this.datastoreService.config.wasteLimits.wasteUnits) {
      this.wasteUnits = this.datastoreService.config.wasteLimits.wasteUnits;
    }
    if (wasteLimitAnswers.length > 0) {
      //
      this.wasteLimit = wasteLimit;
      this.showWasteWarning = true;
      this.scrollToTop();
      this.spinner.hide();
      return;
    } else {
      await this.completeDetails();
    }
  }

  async completeDetails() {
    const email = this.customerDetailsForm.controls['email_address'].value;

    // // Use email/phone to check if the user is banned
    // let res = await this.apiService.checkEmailNumber(email, null, this.selectedDepartment);

    // let checkAccount = new Promise((resolve, reject) => {
    //   if (res == undefined) {
    //     resolve("finished")
    //   }
    //   if (res["_source"] && res["_source"].questions) {
    //     if (res["_source"].questions.length > 0) {
    //       res["_source"].questions.forEach((question, index) => {
    //         if (question.id == 8 && question.answer == "1") {
    //           reject("banned")
    //           this.banned = true;
    //           return;
    //         }
    //         if (index === res["_source"].questions.length - 1) {
    //           resolve("finished");
    //         }
    //       });
    //     } else {
    //       resolve("finished");
    //     }
    //   } else {
    //     resolve("finished");
    //   }
    // });

    // checkAccount.then(async () => {

    this.datastoreService.bookingForm = this.bookingQuestionsForm;
    this.datastoreService.customerDetailsForm = this.customerDetailsForm;
    this.spinner.hide();

    // var currentSlot = new Date(this.slot.datetime).toTimeString();

    // let canContinue = true;
    // this.unavailableTimes.forEach(bookedSlot => {
    //   if (currentSlot.includes(bookedSlot)) {
    //     // if the current slot matches an unavailable time, +1 to can continue (doing it like this so it doesn't break the loop)
    //     canContinue = (false)
    //   }
    // });
    // If canContinue = (there is a match between current slot and unavailable time), then show error, otherwise continue
    // if (!canContinue) {
    //   this.alertService.error(
    //     this.translateService.instant('COMMON.BACK_TO_BACK_BOOKINGS')
    //   );
    //   this.scrollToTop();
    //   this.spinner.hide();
    //   return;
    // } else {
    console.log(this.datastoreService.registration);
    if (this.datastoreService.registration) {
      console.log('here');
      await this.checkVisitorAlertsTable(this.datastoreService.registration);
      console.log(this.datastoreService.banned);
      if (!this.datastoreService.banned) {
        this.router.navigate(['/summary']);
      } else {
        this.scrollToTop();
        this.alertService.warn(
          this.translateService.instant('COMMON.USER_BANNED')
        );
      }
    } else {
      this.router.navigate(['/summary']);
    }
    // }
    // }).catch((e) => {
    //   console.log("ERROR", e);
    //   if (e == "banned") {
    //     this.alertService.warn(this.translateService.instant('COMMON.USER_BANNED'));
    //   } else {
    //     this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'));
    //   }
    //   this.scrollToTop();
    //   this.spinner.hide();
    // });
  }

  // Scroll to the top of the page
  scrollToTop() {
    window.scroll(0, 0);
  }

  // Number input text validation, keycode 8 is backspace
  keyPressNumberField(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
